import { render, staticRenderFns } from "./ModuleBrandEdit.vue?vue&type=template&id=0a0932a3"
import script from "./ModuleBrandEdit.vue?vue&type=script&lang=js"
export * from "./ModuleBrandEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports